// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"1f022561","455":"e8aa3e3a","977":"7a226912"}[chunkId] + ".chunk.js";
};